<div>

  <div class="treetable-wrap"
       [ngClass]="{'results-table': tree.length > 0, 'table-container': tree.length > 0}"
       [ngStyle]="{'justify-content': justifyTableOnCenter() ? 'center' : 'initial'}">

    <ng-container #treeTableView></ng-container>
    <ng-template #treeTableTemplate>
      <treetable #treeTable
                 class="wide"
                 *ngIf="tree.length > 0"
                 [tree]="tree"
                 [options]="options"
                 (nodeClicked)="nodeClicked($event)"
                 style="width: 100%;"
                 [translateHeaders]="translateHeaders"
      ></treetable>
    </ng-template>

  </div>

  <div *ngIf="!hideSaveButtons" class="results-container media-button-container">
    <button
      [id]="getPrefixedId('saveToPc_button')"
      mat-button
      class="btn-green save-media-button"
      (click)="openSaveDialog(false)"
    >{{'RESULTS.GENERAL.SAVE_CSV_FILE_TO_PC' | anessaTranslation: trigger}}
    </button>
  </div>

</div>
